import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-white" data-id="element-54">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-forest text-cream rounded-3xl p-8 md:p-12 shadow-2xl border-4 border-gold/20 relative overflow-hidden" data-id="element-56">
          {/* Decorative shield background */}
          <ShieldCheck className="absolute -right-10 -bottom-10 w-64 h-64 text-forest-light opacity-50 pointer-events-none" data-id="element-57" />

          <div className="relative z-10 flex flex-col md:flex-row items-center md:items-start text-center md:text-left" data-id="element-58">
            <div className="bg-gold p-4 rounded-full mb-6 md:mb-0 md:mr-8 flex-shrink-0 shadow-gold-glow" data-id="element-59">
              <ShieldCheck className="w-12 h-12 text-forest-dark" data-id="element-60" />
            </div>

            <div data-id="element-61">
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-62">
                GARANTÍA DE "GLUCOSA BLINDADA" POR 7 DÍAS
              </h2>
              <p className="text-lg text-cream-dark leading-relaxed" data-id="element-63">
                Prueba el Código Metabólico Latino por una semana completa.
                Aplica el orden de los alimentos y el truco del vinagre. Si en 7
                días no sientes más energía y ves tus números mejorar, mándanos
                un email y te devolvemos cada centavo. Sin preguntas.{' '}
                <strong className="text-gold" data-id="element-64">
                  El riesgo es nuestro, no tuyo.
                </strong>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}